import type { ScannedTicket } from '../hooks/scannedTicketUtils';
import type { ThemePalette } from '../theme/tokens';
import { formatUsd } from '../data/lotteryData';

export type TicketStatus = ScannedTicket['status'] | 'lost';

/** Short pill label shown on a ticket card / in the detail sheet header. */
export function statusLabel(status: string, prize: number | undefined): string {
  if (status === 'jackpot')
    return prize && prize > 0 ? `Jackpot, ${formatUsd(prize)}` : 'Jackpot win';
  if (status === 'won-small') return prize && prize > 0 ? `Won ${formatUsd(prize)}` : 'Won a prize';
  if (status === 'pending') return 'Waiting on draw';
  if (status === 'unknown-draw') return 'Results not ready';
  return 'No win';
}

export function statusBg(status: string, c: ThemePalette): string {
  if (status === 'jackpot') return c.lucky;
  if (status === 'won-small') return c.win;
  if (status === 'lost') return c.surfaceAlt;
  return c.accent2;
}

export function statusFg(status: string, c: ThemePalette): string {
  if (status === 'jackpot' || status === 'won-small') return '#fff';
  if (status === 'lost') return c.inkSoft;
  return c.ink;
}
